import React, { Fragment } from "react";
import Chat from "./Chat";
import Searchbar from "./Searchbar";
import Notificationbar from "./Notificationbar";
import UserHeader from "./UserHeader";
import { Col } from "reactstrap";
import NotificationProvider from "../../../../Notifications/NotificationContext";
import ChatProvider from "../../../../Chat/ChatProvider";
import TotalPoints from "./TotalPoints";

const RightHeader = () => {
  return (
    <Fragment>
      <Col
        xxl="7"
        xl="6"
        md="7"
        className="nav-right pull-right right-header col-8 p-0 ms-auto"
      >
        <ul className="simple-list nav-menus flex-row align-items-center">
          <Searchbar />

          <NotificationProvider>
            <Chat />
            <Notificationbar />
          </NotificationProvider>
          <TotalPoints />

          <li className="px-2 d-none d-sm-flex align-items-center">
            <a
              href="/plan.php"
              target="_blank"
              rel="noopener noreferrer"
              className="fw-bold text-primary text-decoration-underline"
              style={{ fontSize: "13px", whiteSpace: "nowrap" }}
            >
              Upgrade Plan <i className="fa fa-external-link ms-1 f-12"></i>
            </a>
          </li>

          <UserHeader />
        </ul>
      </Col>
    </Fragment>
  );
};

export default RightHeader;
